import {
  EventEmitter,
  Component,
  Input,
  Output,
  ViewChildren,
  QueryList,
  OnChanges,
} from "@angular/core";
import { ProductsMenu } from "src/app/core/entities/productMenu";
import { ProductService } from "src/app/core/services/product-service";

@Component({
  selector: "app-treeview-link",
  templateUrl: "./treeview-link.component.html",
  styleUrls: ["./treeview-link.component.css"],
})
export class TreeviewLinkComponent {
  @ViewChildren(TreeviewLinkComponent)
  public submenu: QueryList<TreeviewLinkComponent>;
  @Input()
  public item: ProductsMenu;
  @Input()
  public parent: string = "";
  @Output()
  public onSelect = new EventEmitter<any[]>();
  @Output() breadCrumb = new EventEmitter<string>();
  @Output() children = new EventEmitter<any>();
  @Input()
  public selected: boolean = false;
  @Input()
  public viewName: string = "";
  public showItems: boolean;
  public breadCrumb1: string = "";
  constructor(public productService: ProductService) {
    this.showItems = false;
  }

  public onChildrenSelected(data: any[], id) {
    data.forEach((d) => {
      const child = this.item.children.find((item) => item.id == d.id);
      if (child) child.selected = d.include;
    });

    const hasChildrenUnselected =
      this.item.children.filter((item) => !item.selected).length > 0;

    this.selected = !hasChildrenUnselected;

    data.push({ include: this.selected, id: this.item.id });

    this.onSelect.emit([id]);
  }

  public addObjectWithoutDuplicates(newItem, array) {
    const isDuplicate = array.some(
      (item) => item.name === newItem.name || item.id === newItem.id
    );
    if (!isDuplicate) {
      return true;
    } else {
      return false;
    }
  }
  saveBc(bc) {
    this.breadCrumb1 = bc;
    this.breadCrumb.emit(bc);
  }
  public select(item: ProductsMenu): void {
    this.productService.filtro["menuIds"] = [item.id];
    this.breadCrumb.emit(this.parent + " > " + item.description);
    // localStorage.setItem("breadCrumb", this.parent+ " > "+ item.description)
    localStorage.setItem(
      "selectedItem",
      JSON.stringify([
        {
          parent: this.parent,
          items: [{ name: item.description, id: item.id }],
        },
      ])
    );
    // }
    // for (let i = 0; i < document.getElementsByTagName("input").length; i++) {
    //   if (document.getElementsByTagName("input")[i].type === "checkbox") {
    //     if(document.getElementsByTagName("input")[i].checked && flag){
    //       document.getElementsByTagName("input")[i].dispatchEvent(eventoMudanca)
    //       flag = false
    //     }
    //   }
    // }
    this.selected = !this.selected;

    const ids = [];
    ids.push({ include: true, id: item.id });
    this.getSubMenu(ids);
    this.onSelect.emit([item.id]);
  }

  private getSubMenu(ids: any[]) {
    if (this.submenu.length)
      this.submenu.forEach((subItem) => {
        subItem.selected = this.selected;
        ids.push({ include: this.selected, id: subItem.item.id });
        subItem.getSubMenu(ids);
      });
  }

  public selectAll(desc, item) {
    for (let i = 0; i < document.getElementsByTagName("input").length; i++) {
      if (document.getElementsByTagName("input")[i].type === "checkbox") {
        document.getElementsByTagName("input")[i].checked = false;
      }
    }
    var botao: any = document.getElementsByClassName(desc + "-check");
    var eventoMudanca = new Event("change", {
      bubbles: true,
      cancelable: true,
    });
    for (let i = 0; i < botao.length; i++) {
      if (botao[i].checked === false) {
        botao[i].dispatchEvent(eventoMudanca);
      }
    }
  }
}
